<template>
  <div class="lp">
    <FirstView :animate-step="animateStep" />
    <Navigation />
    <Outline />
    <Map />
    <Event />
    <Shop />
    <Staff />
    <LiveStream />
    <a href="#" v-scroll-to="'#app'" class="pagetop">PAGETOP</a>
  </div>
</template>

<script>
import FirstView from "../organisms/TheFirstViewSection";
import Navigation from "../organisms/TheNavigation";
import Outline from "../organisms/TheOutlineSection";
import Map from "../organisms/TheMapSection";
import Event from "../organisms/TheEventSection";
import Staff from "../organisms/TheStaffSection";
import Shop from "../organisms/TheShopSection";
import LiveStream from "../organisms/TheLiveStreamSection";

export default {
  name: "LandingPage",
  components: { Shop, Staff, Event, Map, Outline, Navigation, FirstView, LiveStream },
  props: {
    animateStep: Number
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.lp {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0;
  z-index: 5;
  width: 100%;
  min-height: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0 auto;
}
.pagetop {
  font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
  font-style: italic;
  font-weight: bold;
  color: #fff;
  text-decoration: none;
  font-size: 0.75rem;
  background: url("../../assets/icon_pagetop.svg") no-repeat 50% 100%;
  padding: 0 0 36px;
  margin: 0 0 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/templates/LandingPage.vue